import { EMAIL_REGEX } from 'constants/regex'

export interface ErrorMessages {
  email?: string
  password?: string
}

export function validateEmail({ email }: ErrorMessages): ErrorMessages {
  const errors: ErrorMessages = {}
  email = email ? email.trim() : ''

  if (email.length === 0) {
    errors["email"] = "Email is required"
  } else if (!email.match(EMAIL_REGEX)) {
    errors["email"] = "Email is not a valid email"
  }

  return errors
}

export function validatePassword({ password }: ErrorMessages): ErrorMessages {
  const errors: ErrorMessages = {}
  password = password || ''

  if (password.length === 0) {
    errors['password'] = 'Password is required'
  } else if (password.length < 8) {
    errors['password'] = 'Password must have at least 8 characters'
  }

  return errors
}
